export class CanaisComunicacaoWhatsAppChatAudio {
  public audioUrl: string;
  public mimeType: string;

  constructor() { }
}
